import React, {FC, useEffect, useState} from 'react';
import AppUtil from "../../util/AppUtil";
import {Option} from "../../models/SGB";
import tickManager from "../../service/TickManager";
import AllOptionComponent from "./AllOptionsComponent";
import AppConstants from "../../util/AppConstants";
import {RadioComponent} from "../util/RadioComponent";
import {OptionSorter} from "../../models/Quote";
import {OptionOppComponent} from "./OptionsOppComponent";
import {DeepOppComponent} from "./DeepOppComponent";
import {PositionsComp} from "./PositionsComp";
// import SqoffCombos from "./SqoffCombos";
import SqueezeComp from "./SqueezeComp";
import {NavLink, useParams} from "react-router-dom";
import PositionsDeepAnalyser from "./PositionsDeepAnalyser";
import SqOffFuturesComp from "./SqOffFuturesComp";
import ComboOrderaComp from "./ComboOrdersComp";
import OptionConfigComponent from "./OptionConfigComponent";
import MissedOppComponent from "./MissedOppComponent";
// @ts-ignore
// import faker from 'faker';

let defaultSorter:OptionSorter = (a:Option, b:Option) => 2
const OptionComponent:FC = () => {
    const params = useParams();
    const type = params.type || "all";
    const[flag, setFlag] = useState(false);
    const map = AppConstants.sorterMap
    const [loading, setLoading] = useState(!tickManager.ready);




    useEffect(() => {
        if (!tickManager.ready) {
            const interval = setInterval(() => {
                if (tickManager.ready) {
                    setLoading(false);
                    clearInterval(interval);
                }
            }, 200);
            return () => clearInterval(interval);
        }
    }, []);

    if (loading) {
        return <div style={{textAlign: 'center', marginTop: 40, fontSize: 24}}>Loading...</div>;
    }

    const tabOptions = [
        { label: "all options", value: "all" },
        { label: "sq off future", value: "sqoffuture" },
        { label: "sell holdings", value: "sellholdings" },
        { label: "sq off combos", value: "sqoffcombos" },
        { label: "opp", value: "opp" },
        { label: "positions", value: "positions" },
        { label: "deep analyse", value: "deepanalyse" },
        { label: "deep", value: "deep" },
        { label: "squeeze", value: "squeeze" },
        { label: "orders", value: "orders" },
        { label: "config", value: "config" },
        { label: "missed opp", value: "missedopp" },
    ];
    return<>

        <div className="option-tabs">
            {tabOptions.map(tab => (
                <NavLink
                    key={tab.value}
                    to={`/option/type/${tab.value}`}
                    className={() =>
                        `option-tab${type === tab.value ? ' active' : ''}`
                    }
                    style={{ textDecoration: 'none' }}
                >
                    {tab.label}
                </NavLink>
            ))}
        </div>

        {type==="all" ? <AllOptionComponent/> : <></>}
        {type==="sqoffuture" ? <SqOffFuturesComp/> : <></>}
        {/*{type==="sqoffcombos" ? <SqoffCombos /> : <></>}*/}
        {type==="opp" ? <OptionOppComponent/> : <></>}
        {type==="positions" ? <PositionsComp/> : <></>}
        {type==="deepanalyse" ? <PositionsDeepAnalyser/> : <></>}
        {type==="deep" ? <DeepOppComponent/> : <></>}
        {type==="squeeze" ? <SqueezeComp/> : <></>}
        {type==="orders" ? <ComboOrderaComp/> : <></>}
        {type==="config" ? <OptionConfigComponent/> : <></>}
        {type==="missedopp" ? <MissedOppComponent/> : <></>}
        </>
}

export default OptionComponent